export default "__VITE_ASSET__DCC$ponX__"